// extracted by mini-css-extract-plugin
module.exports = {"battery_zoom_tooltip_extend":"Stop_battery_zoom_tooltip_extend__1MZUA","stop_tooltip":"Stop_stop_tooltip__1h8eC","stop_tractor":"Stop_stop_tractor__34Cn1"};